module.exports = "https://asset.exam-sp.com/release/edm-score/webapp/img/BKYS01_logo.985013eb.png";